export class GoalsPopup{
    public GoalsPopupId:number;
    public Visibility:boolean;
    public UpdatedBy:string;
    public UpdatedOn:Date;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/goals-popup.ts